import * as i0 from '@angular/core';
import { Component } from '@angular/core';
import { uuid } from '@primeuix/utils';
import { BaseIcon } from 'primeng/icons/baseicon';
let ArrowDownIcon = /*#__PURE__*/(() => {
  class ArrowDownIcon extends BaseIcon {
    pathId;
    ngOnInit() {
      this.pathId = 'url(#' + uuid() + ')';
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵArrowDownIcon_BaseFactory;
      return function ArrowDownIcon_Factory(__ngFactoryType__) {
        return (ɵArrowDownIcon_BaseFactory || (ɵArrowDownIcon_BaseFactory = i0.ɵɵgetInheritedFactory(ArrowDownIcon)))(__ngFactoryType__ || ArrowDownIcon);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ArrowDownIcon,
      selectors: [["ArrowDownIcon"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 6,
      vars: 7,
      consts: [["width", "14", "height", "14", "viewBox", "0 0 14 14", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M6.99994 14C6.91097 14.0004 6.82281 13.983 6.74064 13.9489C6.65843 13.9148 6.58387 13.8646 6.52133 13.8013L1.10198 8.38193C0.982318 8.25351 0.917175 8.08367 0.920272 7.90817C0.923368 7.73267 0.994462 7.56523 1.11858 7.44111C1.24269 7.317 1.41014 7.2459 1.58563 7.2428C1.76113 7.23971 1.93098 7.30485 2.0594 7.42451L6.32263 11.6877V0.677419C6.32263 0.497756 6.394 0.325452 6.52104 0.198411C6.64808 0.0713706 6.82039 0 7.00005 0C7.17971 0 7.35202 0.0713706 7.47906 0.198411C7.6061 0.325452 7.67747 0.497756 7.67747 0.677419V11.6877L11.9407 7.42451C12.0691 7.30485 12.2389 7.23971 12.4144 7.2428C12.5899 7.2459 12.7574 7.317 12.8815 7.44111C13.0056 7.56523 13.0767 7.73267 13.0798 7.90817C13.0829 8.08367 13.0178 8.25351 12.8981 8.38193L7.47875 13.8013C7.41621 13.8646 7.34164 13.9148 7.25944 13.9489C7.17727 13.983 7.08912 14.0004 7.00015 14C7.00012 14 7.00009 14 7.00005 14C7.00001 14 6.99998 14 6.99994 14Z", "fill", "currentColor"], [3, "id"], ["width", "14", "height", "14", "fill", "white"]],
      template: function ArrowDownIcon_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg", 0)(1, "g");
          i0.ɵɵelement(2, "path", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "defs")(4, "clipPath", 2);
          i0.ɵɵelement(5, "rect", 3);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.getClassNames());
          i0.ɵɵattribute("aria-label", ctx.ariaLabel)("aria-hidden", ctx.ariaHidden)("role", ctx.role);
          i0.ɵɵadvance();
          i0.ɵɵattribute("clip-path", ctx.pathId);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("id", ctx.pathId);
        }
      },
      encapsulation: 2
    });
  }
  return ArrowDownIcon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ArrowDownIcon };
